export function GetSessionItem(dataItem) {
    return window.sessionStorage.getItem(dataItem);
  }

 export function SetSessionItem(item, dataItem) {
    window.sessionStorage.setItem(item, dataItem);
  }